export default "__VITE_ASSET__DTkbaIt___"